import { DateObject } from "react-multi-date-picker";

export const CampaignonvertUnixToGregorian = (unixMs) => {
  const date = new DateObject({ date: unixMs });
  return date.format("YYYY-M-D");
};
